import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import ThemeToggle from "./ThemeToggle";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <ThemeToggle />
      <form style={styles.card} onSubmit={submit}>
        <div style={styles.brand}>AlgoDesk</div>
        <div style={styles.sub}>Sign in to your trading terminal</div>

        <label style={styles.label}>Username</label>
        <input
          style={styles.input}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />

        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.button} disabled={busy}>
          {busy ? "Signing in..." : "Log In"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "var(--bg)",
  },
  card: {
    width: 340, background: "var(--panel)", border: "1px solid var(--border)",
    borderRadius: 10, padding: "32px 28px", display: "flex", flexDirection: "column",
  },
  brand: { fontFamily: "var(--font-mono)", fontSize: 22, fontWeight: 600, letterSpacing: 0.5 },
  sub: { color: "var(--text-dim)", fontSize: 12, marginTop: 4, marginBottom: 24 },
  label: { fontSize: 11, color: "var(--text-dim)", marginTop: 14, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 },
  input: {
    background: "var(--panel-alt)", border: "1px solid var(--border)", borderRadius: 6,
    color: "var(--text)", padding: "9px 10px", fontSize: 13,
  },
  button: {
    marginTop: 22, background: "var(--accent)", color: "#04140a", border: "none",
    borderRadius: 6, padding: "10px 0", fontWeight: 600, cursor: "pointer", fontSize: 13,
  },
  error: { color: "var(--danger)", fontSize: 12, marginTop: 12 },
};
